import { render, staticRenderFns } from "./NewResetPassword.vue?vue&type=template&id=1ddd2aba&"
import script from "./NewResetPassword.vue?vue&type=script&lang=js&"
export * from "./NewResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports